
import { KpiBenchmarkTable } from './tables/KpiBenchmarkTable';
import { ChemicalSafetyBenchmarkTable } from './tables/ChemicalSafetyBenchmarkTable';
import { PerformanceLegend } from './PerformanceLegend';

export const BenchmarkTable = () => {
  return (
    <div className="space-y-8">
      {/* KPI Benchmarks Table */}
      <KpiBenchmarkTable />

      {/* Chemical Safety Benchmarks Table */}
      <ChemicalSafetyBenchmarkTable />

      {/* Legend */}
      <PerformanceLegend />
    </div>
  );
};
